<template>
  <div id="app">
    <top-menu
        v-if="showTopMenu"
    ></top-menu>
    <alert v-if="alert_info.alert"
           :class="alert_info.data.alert_class"
           :data="{title:alert_info.data.alert_title, body:alert_info.data.alert_body,
           html:alert_info.data.html || null, closeable:true}"
           @close="dismissAlert"
    ></alert>
    <router-view></router-view>
    <!-- <documentation-panel :question-object="questionObject"></documentation-panel> -->
    <!-- <documentation-panel-tab @questionObject="(input) => questionObject=input"></documentation-panel-tab> -->
     <side-panel></side-panel>
    <!--<side-panel-tab class="uk-visible@m"></side-panel-tab>-->
    <spinner-overlay v-if="loading"></spinner-overlay>
  </div>
</template>

<script>

import topMenu from './components/theme/Menu.vue'
import SidePanel from './components/theme/SidePanel.vue'
import SidePanelTab from './components/theme/SidePanelTab.vue'
import alert from './components/theme/Alert'
import { mapGetters } from 'vuex'
import DocumentationPanel from './components/theme/DocumentationPanel'
import DocumentationPanelTab from './components/theme/DocumentationPanelTab'
import SpinnerOverlay from "./components/theme/SpinnerOverlay.vue"

export default {
  name: 'app',
  components: {
    topMenu,
    SidePanel,
    SidePanelTab,
    alert,
    DocumentationPanel,
    DocumentationPanelTab,
    SpinnerOverlay

  },
  data: function() {
    return {
      questionObject: null,
      pathsToHideTopMenu: ['/login']
    }
  },
  methods: {
    dismissAlert: function() {
      this.$store.dispatch('globalAlertReset', {}).then(function(){
        console.log("RESET ALERT")
      }).catch(function(error){
        console.log(error)
      })
    }
  },
  watch: {
    loading: function (load) {
      if (load) {
        let _t = this
        setTimeout(() => {
          _t.$store.state.loading = false
        }, 30000)
      }
    }
  },
  computed: {
    alert_info: function() {
    	return this.$store.state.globalAlert;
    },
    showTopMenu: function() {
    	// return this.pathsToHideTopMenu.filter(d => d === this.$router.currentRoute.path).length === 0
      return true;
    },
    loading: function() {
      return this.$store.state.loading
    }
  },
  mounted() {
  	console.log(this.pathsToHideTopMenu.filter(d => d === this.$router.currentRoute.path))
  }
}
</script>

<style lang="less">

  @import "../node_modules/uikit/src/less/uikit.less";
  @import "./assets/less/theme.less";
  @import "./assets/less/custom.less";
  @import "../node_modules/intro.js/introjs.css";

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;



  }

  html{
    min-height: 100%;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-repeat:no-repeat;
    background-size: cover;
    background: rgb(255, 250, 250);
    background: -moz-linear-gradient(178deg, rgba(255, 250, 250, 0.8) 65%, rgba(140, 141, 188, 0.8) 86%, rgba(55, 90, 139, 0.8) 84%);
    background: -webkit-linear-gradient(178deg, rgba(255, 250, 250, 0.8) 65%, rgba(140, 141, 188, 0.8) 86%, rgba(55, 90, 139, 0.8) 84%);
    background: linear-gradient(178deg, rgba(255, 250, 250, 0.1) 72%, rgba(@primary-4, .4) 88%, rgba(55, 90, 139, 0.3) 97%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#fffafa",endColorstr="#375a8b",GradientType=1);
  }

  body{

  }


</style>
